// src/utils/imageAssets.js

// Define relative paths to your images
const imageAssets = {
    // For photo type previews
    'team-branded': '/images/cheerleader-team-branded.jpg',              // Cheerleader with bulldog logo
    'team-branded-group': '/images/cheerleader-duo.jpg',        // Team with gold spotlights
    'individual': '/images/cheerleader-duo-clean.jpg',                // Two cheerleaders
    'small-group': '/images/cheerleader-duo.jpg',               // Two cheerleaders
    'team': '/images/cheer-team-gold.jpg',                      // Team in B&W
    'collage': '/images/cheer-champions.jpg',                   // Cheer champions
    
    // Fallback image
    'default': '/images/cheer-champions.jpg'
  };
  
  // Helper function to get the correct image path
  export const getImagePath = (key) => {
    return imageAssets[key] || imageAssets.default;
  };
  
  export default imageAssets;